import { lumberjackBackend } from "../../_Bootstrap/Logging";

/**
 * Export all the logs in batches
 */
export const exportLogs = async (
    onBatch: (entries: Array<string>) => MaybePromise<void>
): Promise<void> => {
    console.log("Starting to write logs");
    await lumberjackBackend.exportBatch(async entries => {
        console.log(`Writing batch of ${entries.length} logs`);

        await onBatch(
            entries.map(
                entry => `${entry.timestamp}|(${(entry.contextId || "Default")}) [${entry.level}] ${entry.message.replace("\n", "\\n")}`
            )
        );
    }, 5000);
    console.log("Finished writing logs");
};

/**
 * Retrieve all the logs as a single string
 */
export const exportLogsAsString = async (): Promise<string> => {
    const logs: Array<string> = [];

    await exportLogs(rows => {
        logs.push(...rows);
    });

    return logs.join("\r\n");
};
